import React, { useEffect, useState } from "react";

import NextImage from "../common/NextImage";
import { getAgeString } from "../../utils/generalLiveCenter";
import { loadStyles } from "../../utils/cssLoader";

const CricketPlayerDetailHead = ({
  ServerData,
  dictionary = {},
  loadCSS = true,
  dataClient = false,
  title,
  sport = "cricket",
}) => {
  const [clientData, setClientData] = useState(null);

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("cricketplayer");
    }
  }, [loadCSS]);

  const data = dataClient ? clientData : ServerData;
  const playerData = data?.data;

  if (!playerData) {
    return null;
  }

  const { nm, role, age, basty, bosty, gender, born, pid } = playerData;
  const imgUrl = `https://cric.livescoring.cc/playerimages/${pid}.png`;

  return (
    <>
      {title && <h1>{title}</h1>}
      <div className="leag_main_head player-head">
        <div className="up_head">
          <div className="up_wrap">
            <div className="icon_flag">
              <NextImage
                src={imgUrl}
                width={60}
                height={60}
                alt="player"
                priority={true}
              />
            </div>
            <div className="info_wrap">
              <h2 className="a">
                <strong className="name">{nm}</strong>
              </h2>
            </div>
          </div>
        </div>
        <div className="venue_wrap">
          <ul>
            <li>
              <span className="lb">{dictionary?.dateOfBirth || "Date of Birth"} :</span>
              {born ? `${getAgeString(born)}` : "-"}
            </li>
            {gender && (
              <li>
                <span className="lb">{dictionary?.gender || "Gender"} :</span>
                {gender || "-"}
              </li>
            )}
            <li>
              <span className="lb">{dictionary?.age || "Age"} :</span>
              {age === null ? "-" : age}
            </li>
          </ul>
        </div>
        <div className="venue_wrap">
          <ul>
            <li>
              <span className="lb">{dictionary?.role || "Role"} :</span>
              {role || "-"}
            </li>
            <li>
              <span className="lb">{dictionary?.bowlingStyle || "Bowling Style"} :</span>
              {bosty || "-"}
            </li>
            <li>
              <span className="lb">{dictionary?.battingStyle || "Batting Style"} :</span>
              {basty || "-"}
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default CricketPlayerDetailHead;
